var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper",class:[{'is-visible': true}],attrs:{"id":"app-wrapper"}},[_c('statewide-main')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }